const SUBMISSION_TABLE_INPUT_TYPE_KEYS = [
    'INPUT',
    'RADIO',
    'CHECKBOXES',
    'MULTI_SELECT_DROPDOWN',
    'URL',
    'INPUT_TEXT',
    'EMAIL',
    'TEL',
] as const;

export const SUBMISSION_TABLE_INPUT_TYPE_SET = new Set<string>(SUBMISSION_TABLE_INPUT_TYPE_KEYS);

export const SortOrder = {
    SUBMITTED_TIME_DESC: '-submissionTime',
    SUBMITTED_TIME_ASC: 'submissionTime',
} as const;
